import { render, staticRenderFns } from "./ExportResourceDialog.vue?vue&type=template&id=834253b6&scoped=true"
import script from "./ExportResourceDialog.vue?vue&type=script&lang=js"
export * from "./ExportResourceDialog.vue?vue&type=script&lang=js"
import style0 from "./ExportResourceDialog.vue?vue&type=style&index=0&id=834253b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834253b6",
  null
  
)

export default component.exports